module.exports = __webpack_public_path__ + "img/stop-solid.388c99c2.svg";